module.exports = __webpack_public_path__ + "static/media/ruzena.4e162a8a.jpg";